var map = {
	"./3d.png": "../../../libs/backgammon/src/components/preferences/assets/thumbnails/3d.png",
	"./classic.png": "../../../libs/backgammon/src/components/preferences/assets/thumbnails/classic.png",
	"./wooden.png": "../../../libs/backgammon/src/components/preferences/assets/thumbnails/wooden.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../../libs/backgammon/src/components/preferences/assets/thumbnails sync recursive ^\\.\\/.*$";